export default __webpack_public_path__ + "static/icon-a60c34d955e0904e72c55551bb88354e.png";